import React from 'react'
import { PropTypes } from 'prop-types';

export class RunningText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return (  
            <div className="col-md-12 col-12">
            <div className="form-group"> 
            <h5> {this.props.field_label}</h5>
            </div>
            </div>
        );
    }
}

RunningText.propTypes = {
  field_label: PropTypes.string,
}
 
export default RunningText;